import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TOrderStatus } from '@chemist2u/types-client/C2U/Interfaces';
import { ImageComponent } from '../../primitives/image/image.component';

export type OrderStatusMapping = {
  [K in TOrderStatus | "Ready For Collection" | "Collected"]: TStatus;
};

export type TStatus = 'reviewing'| 'delivered'| 'collected'| 'awaiting-dispatch' | 'awaiting-collection'| 'on-the-way'| 'preparing-order'| 'payment-requested'| 'cancelled'| 'completed';

export type TStatusProps = {
  label: string,
  icon: string,
  class: string,
  altName: string
};

@Component({
    selector: 'app-status-tag',
    templateUrl: './status-tag.component.html',
    styleUrls: ['./status-tag.component.scss'],
    imports: [CommonModule, ImageComponent]
})
export class StatusTagComponent {

  public readonly orderStatusMap: OrderStatusMapping = {
    "Approved": "payment-requested",
    "Pending": "reviewing",
    "Paid": "preparing-order",
    "Pharmacy Approved": "preparing-order",
    "Cancelled": "cancelled",
    "Delivered": "delivered",
    "Ready" : "awaiting-dispatch",
    "Ready For Collection" : "awaiting-collection",
    "Unpaid": "reviewing",
    "Shipped Out": "on-the-way",
    "Completed": "completed",
    "Collected": "collected",
  };

  private readonly statusConfig: Map<TStatus, TStatusProps> = new Map([
    ['reviewing', { label: 'Reviewing', icon: 'hourglass', class: 'yellow', altName: 'reviewing icon' }],
    ['delivered', { label: 'Delivered', icon: 'checkmark-circle', class: 'green', altName: 'delivered icon' }],
    ['collected', { label: 'Collected', icon: 'checkmark-circle', class: 'green', altName: 'collected icon' }],
    ['awaiting-dispatch', { label: 'Ready for Dispatch', icon: 'shopping-bag-cursor', class: 'blue', altName: 'ready for dispatch icon' }],
    ['awaiting-collection', { label: 'Ready for Collection', icon: 'shopping-bag-cursor', class: 'blue', altName: 'ready for collection icon' }],
    ['on-the-way', { label: 'On the Way', icon: 'truck_black', class: 'blue', altName: 'on the way icon' }],
    ['preparing-order', { label: 'Preparing Order', icon: 'stacked-tray', class: 'yellow', altName: 'preparing order icon' }],
    ['payment-requested', { label: 'Payment Requested', icon: 'card', class: 'orange', altName: 'card icon' }],
    ['cancelled', { label: 'Cancelled', icon: 'close-circle', class: 'red', altName: 'cancelled icon'  }],
    ['completed', { label: 'Completed', icon: 'checkmark-circle', class: 'green', altName: 'completed icon' }]
  ]);
  private readonly defaultStatus: TStatusProps = { label: 'Unknown', icon: 'newspaper', class: 'yellow', altName: 'unknown icon' };
  
  statusInp = input<TOrderStatus | "Ready For Collection" | "Collected" | undefined>('Pending', {
    alias: 'status'
  });

  status = computed<TStatusProps>(() => {
    const statusInp = this.statusInp();
    if (statusInp == undefined) return this.defaultStatus;
    const mappedStatus = this.orderStatusMap[statusInp];
    return this.statusConfig.get(mappedStatus) || this.defaultStatus;
  });
}